import { render, staticRenderFns } from "./HeroCardDecks.vue?vue&type=template&id=b883ab08&scoped=true"
import script from "./HeroCardDecks.vue?vue&type=script&lang=js"
export * from "./HeroCardDecks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b883ab08",
  null
  
)

export default component.exports